import { OvPoliciesHoc } from '@components'
import { URL_PATHS } from '@constants'
import { useStore } from '@hooks/useStore'
import { observer } from 'mobx-react-lite'
import { Navigate } from 'react-router-dom'

interface IRequireAuth {
  children: JSX.Element
  allowed?: string[]
}

export const RequireAuth = observer(({ children }: IRequireAuth) => {
  const { auth } = useStore()

  if (!auth.is_authenticated) {
    return <Navigate to={URL_PATHS.LOGIN} />
  }

  return <OvPoliciesHoc>{children}</OvPoliciesHoc>
})
